export default __webpack_public_path__ + "static/media/ddsu5168_logo_white.07813521.png";